/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShopInstallmentNonPerformingResponse = {
    id?: string;
    shopReference?: string;
    name?: string;
    status?: ShopInstallmentNonPerformingResponse.status;
    expireAt?: string;
    installmentNonPerformCount?: number;
};
export namespace ShopInstallmentNonPerformingResponse {
    export enum status {
        ACTIVE = 'ACTIVE',
        WAITING_FOR_APPROVE = 'WAITING_FOR_APPROVE',
        EXPIRED = 'EXPIRED',
        SUSPENDED = 'SUSPENDED',
    }
}

